import DEFAULT_THEME from '@maas-components/styles'
import styled from 'styled-components'

export const List = styled.ul`
  margin: 0;
  padding-left: 16px;

  & > li::marker {
    color: ${DEFAULT_THEME.palette.text.secondary};
  }
`
